export default __webpack_public_path__ + "static/media/1961.4abd5e24.png";